/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Usuario de contacto [P_E_15]
 * @export
 * @interface CompanyUser
 */
export interface CompanyUser {
    /**
     * 
     * @type {number}
     * @memberof CompanyUser
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyUser
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyUser
     */
    surname?: string;
    /**
     *
     * @type {string}
     * @memberof CompanyUser
     */
    phone?: string;
    /**
     *
     * @type {boolean}
     * @memberof CompanyUser
     */
    affiliate?: boolean;
}

export function CompanyUserFromJSON(json: any): CompanyUser {
    return CompanyUserFromJSONTyped(json, false);
}

export function CompanyUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'surname': !exists(json, 'surname') ? undefined : json['surname'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'affiliate': !exists(json, 'affiliate') ? undefined : json['affiliate'],
    };
}

export function CompanyUserToJSON(value?: CompanyUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'email': value.email,
        'name': value.name,
        'surname': value.surname,
        'phone': value.phone,
        'affiliate': value.affiliate,
    };
}


